module.exports = __webpack_public_path__ + "static/media/Safe-T21.300f74fc.jpg";